// Central NAP (Name, Address, Phone, Email) – sanningskälla.
// FEN-004: ingen sida får hårdkoda e-post eller adress separat.

export const CONTACT = {
  brand: "Fenny",
  legalName: "Fenny (Norrhavet Group)",
  email: "hey@fenny.se",
  emailMailto: "mailto:hey@fenny.se",
  /** Alias som accepteras men ej visas publikt. */
  emailAliases: ["hej@fenny.se"],
  /** Växel — samma nummer som i strukturerad data och kataloger. */
  phone: "08 480 047 06",
  phoneHref: "tel:+46848004706",
  /** Besöksadress Stockholm. Postnummer tillkommer när det bekräftats. */
  street: "Bjurholmsplan 24",
  city: "Stockholm",
  citiesShort: "Stockholm, Västerås & Malmö",
  citiesLong: "Stockholm, Västerås och Malmö, Sverige",
  country: "SE",
  parent: { name: "Norrhavet Group", url: "https://norrhavet.com" },
} as const;
